import {
    getActiveFilter,
    getActiveFilterFormAttributeByKey, getEmptyRequiredItems, isActiveFilterLinked,
    removeFilterLayer,
    setActiveFilter, setFilterSettings
} from "@/helpers/filter/filter-helper";
import {clearBuffer} from "@/helpers/measure/measure-buffer-helper";
import {clearFilterSelectLayer} from "@/helpers/filter/filter-geometry-helper";
import {getBookmarkPresentationsByID, updateLayerSourceParams} from "@/helpers/ol/ol-layer-helper";
import {escapeOutput} from "@/helpers/output-helper";
import {getOgcInFilter} from "@/helpers/filter/filter-ogc-helper";
import {
    addClassBySelector, getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import $ from "jquery";
import {checkActiveLayerInfoButtons} from "@/helpers/layer/info/layer-info-helper";
import {stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper.js";

export function getDataTableFilterSettings(d, type = undefined) {

    d = getDefaultSettings(d, type)

    let linkedFilterAttribute = undefined

    document.querySelectorAll('layer-info-filter-settings-item').forEach((element) => {

        let key = element.dataset.key

        const formAttribute = getActiveFilterFormAttributeByKey(key)

        if(formAttribute === undefined) {
            return
        }

        if(formAttribute.IsLinkedGeometry) {
            linkedFilterAttribute = formAttribute.attribute.Attribute
        } else {

            let column
            switch (formAttribute.AttributeTypeID) {
                // Alleen zichtbaar in resultaat
                case 1001:
                    break
                // Tekst uniek zoeken
                case 1010:
                    column = getUniqueText(element, d.columns[key])
                    break;
                // Numeriek uniek zoeken
                case 1011:
                    column = getUniqueNumber(element, d.columns[key])
                    break;
                // Numeriek tussen 2
                case 1013:
                    column = getNumberBetween(element, d.columns[key])
                    break;
                // Deel van tekst zoeken
                case 1015:
                    column = getPartOfText(element, d.columns[key])
                    break;
                // Lijst
                case 1022:

                    let operator = "equal"
                    if(formAttribute.ActionAdvancedFourth) {
                        operator = 'like'
                    }

                    console.log(formAttribute)

                    column = getFilterList(element, d.columns[key], operator)
                    break;
                // Multi lijst
                case 1023:
                    column = getFilterListMulti(element, d.columns[key])
                    break;
                // Datum tussen 2
                case 1030:
                    column = getFiltersDateBetween(element, d.columns[key])
                    break;
                // Datum gelijk aan
                case 1031:
                    column = getFiltersDateEqual(element, d.columns[key])
                    break;
                // Datum vanaf
                case 1032:
                    column = getFiltersDateFrom(element, d.columns[key])
                    break;
                // Datum tot
                case 1033:
                    column = getFiltersDateTill(element, d.columns[key])
                    break;
            }

            if (column !== undefined) {
                d.columns[key] = column
            }
        }
    })

    return d
}

export function getPartOfText(element, column) {
    let value = ''
    if(element.querySelector('input')) {
        value = element.querySelector('input').value
    }
    column['search']['value'] = escapeOutput(value)
    column['search']['operator'] = "like"
    column['search']['type'] = "text"
    return column
}

export function getUniqueText(element, column) {

    let value = ''
    if(element.querySelector('input')) {
        value = element.querySelector('input').value
    }

    column['search']['value'] = value
    column['search']['operator'] = "equal"
    column['search']['type'] = "text"
    return column
}

export function getUniqueNumber(element, column) {

    let value = ''
    if(element.querySelector('input')) {
        value = element.querySelector('input').value
    }

    column['search']['value'] = value
    column['search']['operator'] = "equal"
    column['search']['type'] = "numeric"
    return column
}

export function getNumberBetween(element, column) {

    let values = []
    if(element.querySelector('input')) {
        element.querySelectorAll('input').forEach( element => {
            if(element.value !== "") {
                values.push(element.value)
            }
        })
    }

    column['search']['value'] = values.join(';')
    column['search']['operator'] = "between"
    column['search']['type'] = "numeric"
    return column
}

export function getFilterList(element, column, operator = "equal") {

    let value = ''
    if(element.querySelector('select')) {
        let selectedOption = Array.from(element.querySelector('select').options).find(option => option.selected)
        if(selectedOption) {
            value = selectedOption.value
        }
    }

    column['search']['value'] = value
    column['search']['operator'] = operator
    column['search']['type'] = "list"
    return column
}

export function getFilterListMulti(element, column) {

    let values = []
    if(element.querySelector('select')) {
        values = Array.from(element.querySelector('select').options).filter(option => option.selected).map(option => option.value)
    }

    column['search']['value'] = values.join(';')
    column['search']['operator']= "matches"
    column['search']['type']= "multilist"
    return column
}

export function getFiltersDateFrom(element, column) {

    let value = ''
    if(element.querySelector('input')) {
        value = element.querySelector('input').value
    }

    column['search']['value'] = value
    column['search']['operator'] = "from"
    column['search']['type'] = "date"
    return column
}

export function getFiltersDateTill(element, column) {

    let value = ''
    if(element.querySelector('input')) {
        value = element.querySelector('input').value
    }

    column['search']['value'] = value
    column['search']['operator'] = "till"
    column['search']['type'] = "date"
    return column
}

export function getFiltersDateEqual(element, column) {

    let value = ''
    if(element.querySelector('input')) {
        value = element.querySelector('input').value
    }

    column['search']['value'] = value
    column['search']['operator'] = "equal"
    column['search']['type'] = "date"
    return column
}

export function getFiltersDateBetween(element, column) {

    let values = []
    if(element.querySelectorAll('input')) {
        element.querySelectorAll('input').forEach( element => {
            if(element.value !== "") {
                values.push(element.value)
            }
        })
    }

    column['search']['value'] = values.join(';')
    column['search']['operator'] = "between"
    column['search']['type'] = "date"
    return column
}

export function clearFiltersValues() {

    clearBuffer()
    clearFilterSelectLayer()
    removeFilterLayer()
    clearFilterGeometry()

    const activeFilter = getActiveFilter()

    let presentationID = activeFilter.PresentationID
    let bookmarkPresentationID = activeFilter.BookmarkPresentationID
    if(String(window.activeFiltersBookmarkPresentationIDs).includes(',')) {
        presentationID = undefined
        bookmarkPresentationID = window.activeFiltersBookmarkPresentationIDs
    }

    setActiveFilter(bookmarkPresentationID, presentationID)

    // TODO: nav-link-filter-header[]

    setActiveFilterByFormID(activeFilter.ID)
    removeClassBySelector(`.nav-link-filter-header`, 'active')
    addClassBySelector(`.nav-link-filter-header[data-id="${activeFilter.ID}"]`, 'active')


    window.urlParamsObject.waarde = ''

    const bookmarkPresentation = getBookmarkPresentationsByID(activeFilter.BookmarkPresentationID)
    updateLayerSourceParams(activeFilter.BookmarkPresentationID, 'FILTER', bookmarkPresentation.Filter.Filter)

    console.log(bookmarkPresentation.Filter.CQL_FILTER)
    console.log(bookmarkPresentation.Filter.Filter)

    if(!bookmarkPresentation.Filter.Filter && bookmarkPresentation.Filter.CQL_FILTER) {
        updateLayerSourceParams(activeFilter.BookmarkPresentationID, 'CQL_FILTER', bookmarkPresentation.Filter.CQL_FILTER)
    }

    stopDraw()
}

export function resetFilter() {

    const activeFilter = getActiveFilter()
    if(activeFilter) {
        clearFiltersValues()
        const bookmarkPresentation = getBookmarkPresentationsByID(activeFilter.BookmarkPresentationID)
        updateLayerSourceParams(activeFilter.BookmarkPresentationID, 'FILTER', bookmarkPresentation.Filter.Filter)

        hideElementsBySelector('#divActiveFilters')
        hideElementsBySelector('#btnShowFilterLayers')
        hideElementsBySelector('.divFilterSwitcher')
        hideElementsBySelector('#divLayerInfoFilterSettings')
        hideElementsBySelector('#divLayerInfoFilterResult')

        if(window.settings.ShowAllFilters === 2) {
            showElementsBySelector('#divCardFilters')
        } else {
            showElementsBySelector('.divFilterHelpText')
        }

        $("#slcActiveFilter").val('');
        $('#slcActiveFilter').trigger('change');

        hideElementsBySelector('layer-info-filter .btnHideInfoMenu')

        removeClassBySelector('.btn-filter', 'active')

        checkActiveLayerInfoButtons()

        clearBuffer()
        clearFilterSelectLayer()
        removeFilterLayer()
        clearFilterGeometry()
    }
}

export function updateFilterBadge(element, value = null) {
    let innerHtml = ''
    if(value) {
        innerHtml = '<div class="badge badge-outline-secondary badge-pill">' + value + '</div>'
        console.log(element)
        element.closest('.card').querySelector('.card-header').classList.remove('border-danger')
    }
    element.closest('.card-info').querySelector('layer-info-filter-settings-badge').innerHTML = innerHtml

    hideElementsBySelector('#btnShowFilterLayers')

    checkApplyButton()
}

export function checkApplyButton() {
    console.log('checkApplyButton')
    const button = getBySelector('layer-info-filter-settings-apply-button button')
    if(button) {
        button.disabled = getEmptyRequiredItems(getActiveFilter()).length > 0;
    }
}

export function toggleApplyButtonDisabled(disabled = true) {
    console.log('toggleApplyButtonDisabled')
    const button = getBySelector('layer-info-filter-settings-apply-button button')
    if(button) {
        button.disabled = disabled
    }
}

export function clearFilterBadge() {
    document.querySelectorAll('layer-info-filter-settings-badge').forEach(element => {
        element.innerHTML = ''
    })
}

function getDefaultSettings(d, type = undefined) {

    const activeFilter = getActiveFilter()
    const filter = activeFilter.Filter.filter;
    const bookmarkPresentation = getBookmarkPresentationsByID(activeFilter.BookmarkPresentationID)

    if(window.filter_geom) {
        d.geometry = {}
        d.geometryCheck = true
        d.querytype = window.filter_geom_query_type
        d.geometry.coord = window.filter_geom
        d.geometry.column = window.filter_geom_column

        if(type === 'unique') {
            if(activeFilter && activeFilter.form && activeFilter.form.form_attributes && activeFilter.form.form_attributes.find(formAttribute => formAttribute.IsLinkedGeometry)) {
                d.geometry.column = ''
            }
        }
    } else {
        d.geometryCheck = false
    }

    d.filter_linked_with_geometry = false
    d.geometriekoppel = ""
    d.base_filter = ''
    if(bookmarkPresentation) {
        d.base_filter = bookmarkPresentation.Filter.Filter
    }

    d.base_filter_linked = ""
    if(activeFilter.BaseFilter !== '') {
        d.base_filter_linked = activeFilter.BaseFilter
    }

    if(bookmarkPresentation) {
        d.base_filter = getOgcInFilter(bookmarkPresentation.BookmarkPresentationID, bookmarkPresentation.WfsStyle.attribute, bookmarkPresentation.Filter.Filter, false)
    }

    if(
        window.urlParamsObject.presentatie &&
        window.urlParamsObject.presentatie === activeFilter.PresentationName &&
        window.urlParamsObject.waarde &&
        window.urlParamsObject.waarde.includes(',')
    ) {
        // d.base_filter += '<ogc:Or>'

        if(window.urlParamsObject.attribuut) {
            let values = ''
            window.urlParamsObject.waarde.split(',').map(item => {
                values += `<ogc:Literal>${item}</ogc:Literal>`
            })
            // PropertyIsEqual
            d.base_filter += `<ogc:PropertyIsEqualTo><ogc:Function name="in"><ogc:PropertyName>${window.urlParamsObject.attribuut}</ogc:PropertyName>${values}</ogc:Function><ogc:Literal>true</ogc:Literal></ogc:PropertyIsEqualTo>`

        } else {
            window.urlParamsObject.waarde.split(',').map(item => {
                d.base_filter += '<ogc:FeatureId fid="' + item + '"/>'
            })
        }
        // d.base_filter += '</ogc:Or>'
    }

    d.cql_filter = ""
    d.cql_filter_linked = ""

    if(filter.MaxFeatures > 0) {
        // d.length = 0
        d.length = filter.MaxFeatures
    }

    d.columns.map(column => {
        if(column.search.value &&
            column.search.type !== 'multilist' &&
            column.search.type !== 'list'
        ) {
            column.search.value = escapeOutput(column.search.value)
        }
    })

    return d
}

export function clearFilterGeometry() {
    delete window.filter_geom
    delete window.filter_geom_28992
    window.filter_geom_query_type = ''
}

export function setActiveFilterByFormID(formID) {
    const slcActiveFilter = document.getElementById("slcActiveFilter")

    document.querySelector('#slcActiveFilter').querySelectorAll('option').forEach((optionElement, key) => {
        if (window.filters[key] && window.filters[key].ID === parseInt(formID)) {
            slcActiveFilter.selectedIndex = key + 1;
            setFilterSettings(slcActiveFilter.selectedIndex)
        }
    })
}